module.exports = __webpack_public_path__ + "static/media/doc.4ad58751.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/doc.svg
// module id = 1672
// module chunks = 17